import styled from 'styled-components';

const BaseCircle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default BaseCircle;
